export const email = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
export const wholeNumber = /^\d+$/;
export const ASIN = /^(B\d{2}[A-Z\d]{7}|\d{9}[X\d])$/;
export const UPC = /^[0-9]{12}$/;
export const DECIMAL = /^\d+\.?\d*$/;
export const VALID_DATE = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
